import { connect } from 'react-redux';

import { RootState } from '@src/reducers';
import TrustPilotStarsSVG from '@svgComponents/TrustPilotSVG/TrustPilotStarsSVG';
import TrustPilotSVG from '@svgComponents/TrustPilotSVG/TrustPilotSVG';

import styles from './TrustPilotBadge.module.css';
import { getCountryCode } from '../../lendingAPI/lendingAPISelector';

const mapStateToProps = (state: RootState) => ({
    countryCode: getCountryCode(state)
});

interface trustPilotProps {
    countryCode: string;
}

const TrustPilotBadge = ({ countryCode }: trustPilotProps) => {
    return (
        <div className={styles.trustPilotContainer}>
            <a
                href={
                    countryCode === 'de'
                        ? 'https://de.trustpilot.com/review/www.iwoca.de'
                        : 'https://uk.trustpilot.com/review/iwoca.co.uk'
                }
                data-testid="trustpilot-link"
                target="_blank"
                rel="noreferrer">
                <TrustPilotStarsSVG />
                <TrustPilotSVG />
            </a>
        </div>
    );
};

export default connect(mapStateToProps)(TrustPilotBadge);
